(function() {
    'use strict';

    angular.module('app.user', [
        'app.core',
        'mgo-angular-wizard',
        'ngMessages'
      ]);
})();
